var exports = {
  "Q": "xf1bb6bc5--04f10a--content",
};

module.exports = exports;
